import React, { useEffect } from 'react';
import { Box, Button, Paper, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import TopBar from '../../../components/TopBar';
import CustomTextInput from '../../../components/CustomTextInput';
import { FormCheckbox } from '../../../components/FormCheckbox';
import { map } from 'lodash';

const schema = yup.object({
  id: yup.string().uuid('ID must be a valid UUID').required('ID must be a valid UUID'),
  name: yup.string().required('Name is required'),
  email: yup.string().email().required('Email is required'),
  is_embedded: yup.boolean(),
});

export default function PartnerForm({
  onSubmit,
  onCancel,
  initialData = {},
  apiErrors = {},
  readOnly = false,
  edit = false,
  isLoading = false,
}) {
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      id: initialData.id || '',
      name: initialData.name || '',
      email: initialData.email || '',
      is_embedded: Boolean(initialData.is_embedded),
    },
  });

  useEffect(() => {
    map(apiErrors, (value, key) => setError(key, { message: value, type: 'string' }));
  }, [apiErrors, setError]);

  return (
    <Paper elevation={0} sx={{ p: '1rem' }}>
      {!readOnly && (
        <Box sx={{ pt: 2, pb: 3 }}>
          <TopBar title="Partner Form" identifier={initialData.id}>
            <Stack direction="row" spacing={1}>
              <Button variant="outlined" onClick={onCancel} disabled={isLoading}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleSubmit(onSubmit)} disabled={isLoading}>
                Save
              </Button>
            </Stack>
          </TopBar>
        </Box>
      )}
      <Grid container spacing={2}>
        <Grid size={6}>
          <CustomTextInput
            name="id"
            label="Partner ID (UUID)"
            control={control}
            errors={errors}
            readOnly={readOnly}
            disabled={edit}
          />
        </Grid>
        <Grid size={6}>
          <CustomTextInput name="name" label="Partner Name" control={control} errors={errors} readOnly={readOnly} />
        </Grid>
        <Grid size={6}>
          <CustomTextInput
            name="email"
            label="Email"
            control={control}
            errors={errors}
            readOnly={readOnly}
            disabled={edit}
          />
        </Grid>
        <Grid size={6}>
          <FormCheckbox name="is_embedded" control={control} label="Is Embedded" readOnly={readOnly} disabled={edit} />
        </Grid>
      </Grid>
    </Paper>
  );
}
